import React from 'react';
import styled from 'styled-components';
import { Level, Title } from 'rbx';
import { withRouter } from 'react-router-dom';
import { omit } from 'lodash';
import qs from 'querystringify';
import { Input, Radio } from '../../../components/elements';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const TitleWrapper = styled.nav`
  padding-right: 0.5rem;
`;

const StatusType = ({ status, handlePush }) => (
  <Level.Item style={{ marginTop: '30px' }}>
    <Level.Item>
      <TitleWrapper style={{ paddingLeft: '0.5rem' }}>
        <Title className="label">Status</Title>
      </TitleWrapper>
    </Level.Item>
    <Level.Item style={{ marginRight: '10px' }}>
      <div>
        <Radio
          label="ACTIVE"
          name="Type"
          value={status === 'ACTIVE'}
          onChange={() => handlePush({ status: 'ACTIVE' }, 'status')}
        />
      </div>
    </Level.Item>
    <Level.Item>
      <div>
        <Radio
          label="INACTIVE"
          name="Type"
          value={status === 'INACTIVE'}
          onChange={() => handlePush({ status: 'INACTIVE' }, 'status')}
        />
      </div>
    </Level.Item>
  </Level.Item>
);

const Search = ({ name, status, routeState, history }) => {
  const handlePush = (args, key) => {
    const newRoutState = omit(routeState, key);
    history.push(
      `/cms-roles${qs.stringify(
        {
          ...newRoutState,
          ...args,
          page: 1,
        },
        true,
      )}`,
    );
  };

  return (
    <>
      <Wrapper>
        <BoxWrapper className="box">
          <div className="columns">
            <div className="column is-4">
              <Input
                label="Role Name"
                type="text"
                id="Api_Action_Name"
                value={name}
                onChange={place => {
                  handlePush({ name: place.target.value }, 'name');
                }}
                placeholder="Start entering name..."
              />
            </div>
            <div className="column is-4">
              <StatusType status={status} handlePush={handlePush} />
            </div>
          </div>
        </BoxWrapper>
      </Wrapper>
    </>
  );
};

export default withRouter(Search);
